// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZxzE","type":"styles_type__2bjCF","choices":"styles_choices__2t4wd"};